module.exports = __webpack_public_path__ + "static/img/AabbTitle.5ffaa604.png";